// First: reads a Telegram launch (#tgWebAppData) before the router can drop the hash.
import { loadTelegramScript } from './lib/telegram'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { ConfirmProvider } from './components/ui/Confirm'
import { ToastProvider } from './components/ui/Toast'
import { AuthProvider } from './lib/auth'
import { markNewVersion } from './lib/staleChunk'
import { applyTheme, getTheme } from './lib/theme'
import './styles/index.css'

// telegram-web-app.js only when the admin was opened as a Mini App (never in a browser).
void loadTelegramScript()

applyTheme(getTheme()) // restore the operator's saved light/dark choice (public/admin-theme.js did it before paint)

// Deploy recovery (WP-08): Vite reports a chunk of the old build that is gone. The import then
// fails and the page boundary shows «Вышла новая версия админки» instead of a crash.
window.addEventListener('vite:preloadError', () => markNewVersion())

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false } },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary scope="app">
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ConfirmProvider>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </ConfirmProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
